import api from "./api";

const activesService = {
  get: (jwttoken) =>
    api.get(`/actives`, {
      headers: { Authorization: `Bearer ${jwttoken}` },
    }),
  getByCategory: (jwttoken, category) =>
    api.get(`/getActives/${category}`, {
      headers: { Authorization: `Bearer ${jwttoken}` },
    }),
  getActivesWhereUserHasBalance: (jwttoken) =>
    api.get(`/actives/getActivesWhereUserHasBalance/list`, {
      headers: { Authorization: `Bearer ${jwttoken}` },
    }),
  getById: (jwttoken, activeId) =>
    api.get(`/actives/${activeId}`, {
      headers: { Authorization: `Bearer ${jwttoken}` },
    }),
  getLastQuotesByActiveId: (jwttoken, activeId) =>
    api.get(`/actives/getLastQuotesByActiveId/${activeId}`, {
      headers: { Authorization: `Bearer ${jwttoken}` },
    }),
};

export default activesService;
